export default __webpack_public_path__ + "static/media/knitted_hat.a5306a91.png";